/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { Platform } from 'react-native';
import type { FirebaseCrashlyticsTypes } from '@react-native-firebase/crashlytics';

let crashlytics: FirebaseCrashlyticsTypes.Module | null = null;

if (Platform.OS !== 'web') {
  try {
    // crashlytics version - v20.2.0
    const firebaseCrashlytics: typeof import('@react-native-firebase/crashlytics').default =
      require('@react-native-firebase/crashlytics').default;
    crashlytics = firebaseCrashlytics();
  } catch (e) {
    console.log("Firebase Crashlytics doesn't exist: ", e);
    crashlytics = null;
  }
} else {
  crashlytics = null; // web: no-op
}

export { crashlytics };
